import { userRepository } from "src/features/users/repositories/user.repository";
import { LoungeFilterInput, LoungeFilterQuery } from "../types";

export const buildLoungeQuery = async (where: LoungeFilterInput): Promise<LoungeFilterQuery> => {
  let filter: LoungeFilterQuery = {};
  if (where.id) filter.id = where.id;
  if (where.langCode) filter.langCode = where.langCode;
  if (where.currency) filter.currency = where.currency;

  if (where.userIdentifier) {
    const user = await userRepository.getByUnique(where.userIdentifier);
    filter.userId = user?.id ?? where.userIdentifier;
  }
  if (where.status) filter.status = where.status;
  return filter;
};
